import { Point2D } from "datatypes/SoramaLocalApi";

// Compute a moving average of an array of 2D points across a given window width.
export function movingAverage(array: Point2D[], window: number): Point2D[] {
    const averagedArray: Point2D[] = [];

    // Keep running totals and count to prevent us from having to recalculate averages across a big window for every element
    let runningSum = 0;
    let runningCount = 0;

    // The array consists of 2D points, so they are not necessarily evenly spaced across the axis we are 'moving' along.
    // We therefore keep track of the first and last elements that are included in the window, so we can efficiently look ahead and behind.
    let firstIncludedIndex = 0;
    let lastIncludedIndex = -1;

    for (let i = 0; i < array.length; i++) {
        const currentX = array[i].x; // Move center of window

        // Exclude elements from the tail of the window (reduce running totals)
        let lastRemovedElementFound = false;
        while (!lastRemovedElementFound) {
            // Check whether an element at the start falls outside the window now
            if (firstIncludedIndex < array.length && array[firstIncludedIndex].x < currentX - window / 2) {
                runningSum = runningSum - array[firstIncludedIndex].y;
                runningCount--;
                firstIncludedIndex++;
            } else {
                lastRemovedElementFound = true;
            }
        }

        // Include new elements at the head of the window (increase running totals)
        let lastNewElementFound = false;
        while (!lastNewElementFound) {
            // Check whether a new element falls within the window now
            if (lastIncludedIndex < array.length - 1 && array[lastIncludedIndex + 1].x <= currentX + window / 2) {
                lastIncludedIndex++;
                runningCount++;
                runningSum = runningSum + array[lastIncludedIndex].y;
            } else {
                lastNewElementFound = true;
            }
        }

        // Output new average
        averagedArray.push({
            x: currentX,
            y: runningSum / runningCount,
        });
    }

    return averagedArray;
}
